import {
  Box,
  Text,
  Image,
  Flex,
  Divider,
  VStack,
  HStack
} from "@chakra-ui/react";

import { Link } from "react-router-dom";

import {
  FaInstagram,
  FaMapMarkerAlt,
  FaWhatsapp,
  FaHome,
  FaCcVisa,
  FaCcMastercard,
  FaCcAmex,
  FaCcDinersClub,
} from "react-icons/fa";

import {
  RiMailLine,
  RiTimeLine,
  RiQuestionLine,
  RiHeart3Line
} from "react-icons/ri";

import logo from "../../assets/images/logo-white-orange.webp";

const ICON_SIZE = 40;

const PixIcon = () => (
  <svg width="56" height={ICON_SIZE} viewBox="0 0 56 40" style={{ display: "block" }}>
    <rect x="1.5" y="1.5" width="53" height="37" rx="5" fill="none" stroke="#32BCAD" strokeWidth="1.5"/>
    <path d="M28 8 L33 13 L28 18 L23 13 Z" fill="#32BCAD"/>
    <path d="M35 15 L40 20 L35 25 L30 20 Z" fill="#32BCAD"/>
    <path d="M28 22 L33 27 L28 32 L23 27 Z" fill="#32BCAD"/>
    <path d="M16 15 L21 20 L16 25 L11 20 Z" fill="#32BCAD"/>
  </svg>
);

const EloIcon = () => (
  <svg width="56" height={ICON_SIZE} viewBox="0 0 56 40" style={{ display: "block" }}>
    <rect x="1.5" y="1.5" width="53" height="37" rx="5" fill="none" stroke="#FFB600" strokeWidth="1.5"/>
    <text x="28" y="20.5" fill="#FFB600" fontSize="15" fontWeight="900"
      textAnchor="middle" dominantBaseline="middle"
      fontFamily="Arial, Helvetica, sans-serif" letterSpacing="-0.5">
      elo
    </text>
  </svg>
);

const HipercardIcon = () => (
  <svg width="56" height={ICON_SIZE} viewBox="0 0 56 40" style={{ display: "block" }}>
    <rect x="1.5" y="1.5" width="53" height="37" rx="5" fill="none" stroke="#E3002B" strokeWidth="1.5"/>
    <text x="28" y="20.5" fill="#E3002B" fontSize="8.5" fontWeight="900"
      textAnchor="middle" dominantBaseline="middle"
      fontFamily="Arial, Helvetica, sans-serif" letterSpacing="0.6">
      hipercard
    </text>
  </svg>
);


export function Footer() {
  return (
    <Box
      bg="#004a33"
      color="white"
      mt="80px"
      mb={{base: "60px", md: "0px"}}
      width="100%"
    >
      {/* CONTEÚDO PRINCIPAL */}
      <Box
        maxW="1400px"
        mx="auto"
        px={{ base: 6, md: 10 }}
        py={{ base: 10, md: 14 }}
      >
        <Flex
          direction={{ base: "column", md: "row" }}
          justify="space-between"
          gap={{ base: 10, md: 12 }}
        >
          {/* MARCA */}
          <Box flex="1">
            <Image
              src={logo}
              h="42px"
              objectFit="contain"
            />

            <Text
              color="rgba(255,255,255,0.8)"
              lineHeight="1.8"
              maxW="300px"
            >
              As melhores bebidas, kits e acessórios para tornar
              seus momentos ainda mais especiais.
            </Text>

            <HStack mt="20px" spacing={3}>
              <FaMapMarkerAlt color="#fc8f04" />
              <Text fontSize="14px">
                Belo Horizonte e Região Metropolitana
              </Text>
            </HStack>
          </Box>

          {/* LINKS */}
          <Box flex="1">
            <Text
              fontWeight="700"
              mb="16px"
              color="#fc8f04"
            >
              Navegação
            </Text>

            <VStack align="start" spacing={3}>
              <Link to="/">
                <Text _hover={{ color: "#fc8f04" }}>
                  Início
                </Text>
              </Link>

              <Link to="/produtos">
                <Text _hover={{ color: "#fc8f04" }}>
                  Produtos
                </Text>
              </Link>

              <Link to="/quem_somos">
                <Text _hover={{ color: "#fc8f04" }}>
                  Quem Somos
                </Text>
              </Link>

              <Link to="/destaques">
                <Text _hover={{ color: "#fc8f04" }}>
                  Destaques
                </Text>
              </Link>
            </VStack>
          </Box>

          {/* CONTATO */}
          <Box flex="1">
            <Text
              fontWeight="700"
              mb="16px"
              color="#fc8f04"
            >
              Atendimento
            </Text>

            <VStack align="start" spacing={4}>
              <HStack>
                <FaWhatsapp />
                <Text>(31) 97130-1228</Text>
              </HStack>

              <HStack>
                <RiMailLine />
                <Text>contato@boozen.com.br</Text>
              </HStack>

              <HStack align="start">
                <RiTimeLine />
                <Text>
                  Seg à Sex: 13h às 19h
                  <br />
                  Sáb: 11h às 15h
                </Text>
              </HStack>

              <HStack cursor="pointer">
                <RiQuestionLine />
                <Text>Perguntas Frequentes</Text>
              </HStack>
            </VStack>
          </Box>

          {/* PAGAMENTO */}
          <Box flex="1">
            <Text
              fontWeight="700"
              mb="16px"
              color="#fc8f04"
            >
              Formas de Pagamento
            </Text>

            <Flex gap="8px" flexWrap="wrap" align="center">
              <FaCcVisa       size={ICON_SIZE} color="#1A1F71" title="Visa" />
              <FaCcMastercard size={ICON_SIZE} color="#EB001B" title="Mastercard" />
              <FaCcAmex       size={ICON_SIZE} color="#2E77BC" title="American Express" />
              <FaCcDinersClub size={ICON_SIZE} color="#004A97" title="Diners Club" />
              <EloIcon />
              <HipercardIcon />
              <PixIcon />
            </Flex>

            <HStack
              mt="24px"
              spacing={4}
            >
              <FaInstagram
                size={24}
                cursor="pointer"
              />

              <FaHome
                size={22}
                cursor="pointer"
              />
            </HStack>
          </Box>
        </Flex>
      </Box>

      {/* BARRA INFERIOR */}
      <Divider borderColor="rgba(255,255,255,0.15)" />

      <Flex
        maxW="1400px"
        mx="auto"
        px={{ base: 6, md: 10 }}
        py={5}
        direction={{ base: "column", md: "row" }}
        justify="space-between"
        align="center"
        gap={3}
      >
        <Text
          fontSize="13px"
          color="rgba(255,255,255,0.7)"
          textAlign="center"
        >
          © 2026 Boozen • Todos os direitos reservados •
          CNPJ: 49.997.548/0001-47
        </Text>


        <Text fontSize="13px" display="flex">
          Desenvolvido com 
          <RiHeart3Line
            color="#fc8f04"
            size={18}
          />
           por LufeCodev
        </Text>


      </Flex>
    </Box>
  );
}
